var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.0469C24 5.41947 18.6274 0.046875 12 0.046875C5.37259 0.046875 0 5.41947 0 12.0469C0 17.8674 4.14405 22.7201 9.64267 23.8154V14.8626H7.68555V11.6H9.64267V9.64155C9.64267 6.97993 10.7476 5.39746 13.8871 5.39746H16.5009V8.66028H14.8671C13.6449 8.66028 13.5641 9.11598 13.5641 9.96686L13.5597 11.5998H16.5192L16.1728 14.862H13.5597V23.9464C19.4502 23.1819 24 18.1457 24 12.0469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9558c652ee4fef8f26d2d23a911fdd07.svg";
export { ForwardRef as ReactComponent };